import { render } from "./Disciplinary_Appeals.vue?vue&type=template&id=9424ba1e"
import script from "./Disciplinary_Appeals.vue?vue&type=script&lang=js"
export * from "./Disciplinary_Appeals.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__